import { all, takeEvery, put, call } from "redux-saga/effects";
import actions from "./actions";
import { getList, addData } from "../../helpers/fackBackend_Helper";

function* bulkActivationsResponse({ payload: { data } }) {
  try {
    const response = yield call(addData, "/API/V1/Activation/BulkActivation", data);
    if (response?.statusCode == 1200) {
      yield put(actions.createBulkActivationSuccess(response?.message));
    } else {
      yield put(actions.createBulkActivationFailed(response?.message, response?.data));
    }
  } catch (error) {
    yield put(actions.createBulkActivationFailed(error));
  }
}


function* getAvailableICCIDResponse() {
  try {
    const response = yield call(getList, "/API/V1/Activation/AutoPopulatedICCID");
    if (response?.statusCode == 1200) {
      yield put(actions.getAvailableICCIDSuccess(response?.message,response?.data));
    } else {
      yield put(actions.getAvailableICCIDFailed(response?.message));
    }
  } catch (error) {
    yield put(actions.getAvailableICCIDFailed(error));
  }
}


export default function* rootSaga() {
  yield all([takeEvery(actions.BULK_ACTIVATION, bulkActivationsResponse),]);
  yield all([takeEvery(actions.GET_AVAILABLE_ICCID, getAvailableICCIDResponse),]);
}
